module.exports = __webpack_public_path__ + "static/media/myrtle.c35ff8d5.jpg";